/*
 * jQuery SPA scrolling menu plugin
 * http://github.com/rokasLeng/scroller
 *
 * Copyright (c) 2015 Rokas Lengvenis
 * Dual licensed under the MIT and GPL licenses.
 * Uses the same license as jQuery, see:
 * http://jquery.org/license
 *
 * @version 1.0.0
 *
 * Example usage:
 * $('#menu').scroller({
 *    scrollSpeed: 750,
 *    menuClassName: 'scroller'
 * });
 */
jQuery(".page-navigator li>a").css('color','white');
(function ($) {
  $.fn.scroller = function (options) {

    var settings = $.extend({
      scrollSpeed: 750,
      menuClassName: 'scroller',
      activeClass: 'active'
    }, options);

    // Local vars
    var scrollSpeed = settings.scrollSpeed;
    var activeClass = settings.activeClass;
    var menuClassName = settings.menuClassName;

    this.addClass(menuClassName);

    var menu = $('.' + menuClassName);
    var menuLinks = $('.' + menuClassName + ' a');
    var menuTop = menu.offset().top;
    var sectionPos = [];

    $(window).scroll(function () {

//       if (menuTop < $(window).scrollTop()) {
//         menu.addClass('fixed');
//         $('body').css('padding-top', menu.height());
//       } else if (menuTop > $(window).scrollTop()) {
//         menu.removeClass('fixed');
//         $('body').css('padding-top', 0);
//       }

      // If it is bottom of the page and last section is smaller then viewport height
      if ($(window).scrollTop() + $(window).height() == $(document).height()) {
        menuLinks.removeClass(activeClass);
        sectionPos[sectionPos.length - 1].link.addClass(activeClass);
        
      } else {
        // Get active section and make appropriate link active
     $(".page-navigator li>a").css('color','white');
        sectionPos.forEach(function (pos) {
          if ($(window).scrollTop() >= pos.top && $(window).scrollTop() < pos.bottom) {
            menuLinks.removeClass(activeClass);
            pos.link.addClass(activeClass);
          
            
            $(".work-with-us-banner").each(function(){
//             if(isOnScreen($(this))){
              console.log('inside')
//              $(".page-navigator li>a").css('color','white');
//             }
             });
            
             $(".experiences-desc").each(function(){
         if (isOnScreen($(this))) {
//             console.log('yes');
               $(".page-navigator li>a").css('color','white');
             }
            
                });
            $(".experiences-intro").each(function(){ 
               if(isOnScreen($(this))){
//               console.log('no');
            $(".page-navigator li>a").css('color','black');
            }
        
    });
               $("#custom_experiences").each(function(){
            if(isOnScreen($(this))){
             $(".page-navigator li>a").css('color','black');
            }
             });
            
	   
            $("#shopify-section-get-in-touch").each(function(){
            if(isOnScreen($(this))){
             $(".scroll_animation_menu").css('display','none');
            }
              else{
              $(".scroll_animation_menu").css('display','initial');
              }
             });
		 
            // When position above sections remove active links
          } else if ($(window).scrollTop() < sectionPos[0].top) {
            menuLinks.removeClass(activeClass);
            
          }
        });
      }
//       setContrast();
    });

    return menuLinks.each(function (index) {

      // Get section id
      var id = $(this).attr('href').substr(1);
      
      // Get section active area position
      var top = $('#' + id).offset().top - 100;
      var bottom = top + $('#' + id).height();

      sectionPos.push({
        link: $(this),
        top: top,
        bottom: bottom
      });

      $(this).on('click', function (e) {
        e.preventDefault();
        // Move to a given section
        var sectionOffset = $("#" + id).offset().top - 100;
        console.log(sectionPos);
        // ScrollTop has to be integer value, and fractional offset can be returned in chrome
        $('html, body').animate({scrollTop: Math.ceil(sectionOffset)}, scrollSpeed);
      });
    });
  };

}(jQuery));

const rgb = [255, 255, 255];

// Randomly change to showcase updates


function setContrast() {
  // Randomly update colours
  
    
  
// rgb[0] = Math.round(Math.random() * 255);
//   rgb[1] = Math.round(Math.random() * 255);
//   rgb[2] = Math.round(Math.random() * 255);

//   // http://www.w3.org/TR/AERT#color-contrast
//   const brightness = Math.round(((parseInt(rgb[0]) * 299) +
//                       (parseInt(rgb[1]) * 587) +
//                       (parseInt(rgb[2]) * 114)) / 1000);
  const textColour = (brightness > 125) ? 'black' : 'white';
  
  
//     if ((scroll_pos >= element3 && scroll_pos < element4) || (scroll_pos >= element5 && scroll_pos < element6)) {
//       $(".fixed-side-navbar a").css('color', 'black');
//     } else {
//       $(".fixed-side-navbar a").css('color', 'white');
//     }
  

//   $('#bg').css('color', textColour); 
//   $('#bg').css('background-color', backgroundColour);
  
   

  jQuery(".page-navigator li>a").css('color',textColour);
  
}


function isOnScreen(elem) {
	// if the element doesn't exist, abort
  
  	
	if( elem.length == 0 ) {
		return;
	}
 
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop() 
	var viewport_height = $window.height() * .7
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top 
	var height = $elem.height()
	var bottom = top + height - 200

	return ((bottom > viewport_top) && (top < viewport_bottom))
   
}